import { useMutation } from '@apollo/react-hooks'

import { UPDATE_BUSINESS_CORP_DISCOUNT_SETTINGS, ALL_BUSINESSES_QUERY } from '../../queries/businesses'
import {
  IUpdateBusinessCorpDiscountSettingsData,
  IUpdateBusinessCorpDiscountSettingsVariables,
} from '../../types/businesses'

export const useUpdateBusinessCorpSettings = () => {
  const [updateBusinessCorpSettings] = useMutation<
    IUpdateBusinessCorpDiscountSettingsData,
    IUpdateBusinessCorpDiscountSettingsVariables
  >(UPDATE_BUSINESS_CORP_DISCOUNT_SETTINGS)

  return async (businessId: number, enabled: boolean) => {
    await updateBusinessCorpSettings({
      variables: { businessId, corpDiscountEnabled: enabled },
      refetchQueries: [
        {
          query: ALL_BUSINESSES_QUERY,
        },
      ],
    })
  }
}
